import React, { useState } from "react";
import { FaArrowLeft } from "react-icons/fa";
import HeaderContainer from "../CrewDashboard/HeaderContainer";
import { useNavigate } from "react-router-dom"; // Import useNavigate
import LeafletMapTracking from "../CrewDashboard/LeafletMapTracking";

const DriverInteraction = () => {
  const navigate = useNavigate(); // Use useNavigate instead of useHistory

  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const driversPerPage = 15;

  const drivers = Array.from({ length: 20 }, (_, i) => ({
    id: i + 1,
    name: `Driver ${i + 1}`,
    experience: `${Math.floor(Math.random() * 10) + 1
      } Years Driving Experience`,
  }));
  const totalPages = Math.ceil(drivers.length / driversPerPage);

  // Pagination Logic
  const indexOfLastDriver = currentPage * driversPerPage;
  const indexOfFirstDriver = indexOfLastDriver - driversPerPage;
  const currentDrivers = drivers.slice(indexOfFirstDriver, indexOfLastDriver);
  const addNew = () => {
    navigate("/vehicle-assignment");
  };
  const handleSave = () => {
    navigate("/import-data");
  };
  const handleBack = () => {
    sessionStorage.getItem("UserRole") === "1"
      ? navigate("/super-admin")
      : navigate("/manager");
  };

  return (
    <div className="p-6 w-full">
      <HeaderContainer />
      {/* Top Section */}
      <div className="items-center mt-5 personal-info-content">
        <div
          onClick={handleBack}
          className="flex justify-between cursor-pointer items-center w-20 back-button"
        >
          <FaArrowLeft />
          <span>Back</span>
        </div>
        <p className="pt-4 font-semibold text-lg">Driver Interaction</p>
        {/* <span>
          Add a driver, assign company flights, and update details here
        </span> */}
        <div className="d-flex m-4 justify-evenly">
          {/* Map Section */}
          <div className="lg:col-span-1 order-last lg:order-none">
            <div
              className="clean-container p-2 lg:p-0 overflow-hidden"
              style={{ minHeight: "250px" }}
            >
              <div
                className="driver-map-mobile driver-map-tablet w-full h-full flex justify-center items-center"
                style={{
                  height: "300px",
                  minHeight: "300px",
                }}
              >
                <div className="w-full h-full">
                  <LeafletMapTracking driverId="driver-001" />
                </div>
              </div>
            </div>
          </div>

          {/* Trip Details */}
          <div className="lg:col-span-1">
            <div className="clean-container">
              <div className="space-y-3 lg:space-y-4">
                <div>
                  <p className="text-gray-500 text-xs lg:text-sm mb-1">
                    Destination
                  </p>
                  <p className="font-semibold text-gray-800 text-base lg:text-lg">
                    Hilton Los Angeles
                  </p>
                </div>

                <div>
                  <p className="text-gray-500 text-xs lg:text-sm mb-1">
                    Pickup Location
                  </p>
                  <p className="font-semibold text-gray-800 text-sm lg:text-base">
                    Terminal 4,
                  </p>
                  <p className="font-semibold text-gray-800 text-sm lg:text-base">
                    Passenger Pickup Zone
                  </p>
                </div>

                <div>
                  <p className="text-gray-500 text-xs lg:text-sm mb-1">
                    Estimated Drive Time
                  </p>
                  <p className="font-semibold text-gray-800 text-sm lg:text-base">
                    10 minutes
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DriverInteraction;
